<template>
  <div>
    <abf-owner-select size="20" :owners="OwnersList" :selected="customer.owner.id" @update:selected="changeOwner" />
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          size="20"
          class="pl-3"
          :color="customer.referral && !customer.self_referred ? 'success' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-people-carry
        </v-icon>
      </template>
      <span v-if="customer.referral">Referred Customer</span>
      <span v-else>Organic Customer</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform') && customer.has_documents">
      <template v-slot:activator="{ on }">
        <v-icon size="20" class="pl-3" color="success" v-on="on">fad fa-file-alt</v-icon>
      </template>
      <span>Customer has documents</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform') && customer.closed">
      <template v-slot:activator="{ on }">
        <v-icon size="20" class="pl-3" color="error" v-on="on">fad fa-user-times</v-icon>
      </template>
      <span>Customer is closed</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('to_be_called')"
          size="20"
          class="pl-3"
          :color="customer.to_be_called ? 'error' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-phone-plus
        </v-icon>
      </template>
      <span>Flag Customer as 'To be Called'</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('hot_prospect')"
          size="20"
          class="pl-3"
          :color="customer.hot_prospect ? 'error' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-flame
        </v-icon>
      </template>
      <span>Flag Customer as 'Hot Prospect'</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('complaint_raised')"
          size="20"
          class="pl-3"
          :color="customer.complaint_raised ? 'error' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-exclamation-triangle
        </v-icon>
      </template>
      <span>Flag Customer as having raised a complaint</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          :color="customer.trustpilot_invitation_sent ? 'warning' : 'grey lighten-1'"
          @click="switchFlag('trustpilot_invitation_sent')"
          class="pl-3"
          size="20"
          v-on="on"
        >
          fad fa-star
        </v-icon>
      </template>
      <span>Flag Customer as having been sent a TP review invitation</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('trustpilot')"
          size="20"
          class="pl-3"
          :color="customer.trustpilot ? 'warning' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-star
        </v-icon>
      </template>
      <span>Flag Customer as having reviewed us on Trustpilot</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('financials_sent')"
          size="20"
          class="pl-3"
          :color="customer.financials_sent ? 'success' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-envelope-open-dollar
        </v-icon>
      </template>
      <span>Flag Customer as having financials sent</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('auto_send_enquiries')"
          size="20"
          class="pl-3"
          :color="customer.auto_send_enquiries ? 'success' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-shipping-fast
        </v-icon>
      </template>
      <span>Flag Customer as 'Speedy Van'</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform') && customer.has_enquiry_errors">
      <template v-slot:activator="{ on }">
        <v-icon size="24" class="pl-3" color="error" v-on="on">
          fad fa-bug
        </v-icon>
      </template>
      <span>Has Enquiry Errors</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform') && customer.has_enquiry_feedback">
      <template v-slot:activator="{ on }">
        <v-icon size="24" class="pl-3" color="warning" v-on="on">
          fad fa-person-sign
        </v-icon>
      </template>
      <span>Has Enquiry Feedback</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform') && customer.has_enquiry_quote">
      <template v-slot:activator="{ on }">
        <v-icon size="24" class="pl-3" color="success" v-on="on">
          fad fa-envelope-open-text
        </v-icon>
      </template>
      <span>Has Indicative Quote</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="switchFlag('soft_search_consent')"
          size="20"
          class="pl-3"
          :color="customer.soft_search_consent ? 'purple' : 'grey lighten-1'"
          v-on="on"
        >
          fad fa-thumbs-up
        </v-icon>
      </template>
      <span>Flag Customer as having given soft search consent</span>
    </v-tooltip>
    <v-tooltip bottom v-if="UserHasRole('Platform')">
      <template v-slot:activator="{ on }">
        <v-icon
          @click="toggleNewsletter"
          size="20"
          class="pl-3"
          :color="customer.users[0].newsletter_signup ? 'green' : 'grey lighten-1'"
          v-on="on"
        >
          fab fa-mailchimp
        </v-icon>
      </template>
      <span>Customer is subscribed to mailing list</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AbfOwnerSelect from '@/components/Abf/AbfOwnerSelect';

export default {
  name: 'customer-toolbar',
  props: ['customer'],
  components: {
    AbfOwnerSelect
  },
  data: () => ({
    showCloseDialog: false,
    showCustomerEdit: false,
    showDeleteDialog: false,
    fab: false,
    page: 'customer'
  }),
  computed: {
    ...mapGetters(['OwnersList', 'UserHasRole']),
    progressColour() {
      let colour = 'red';
      if (this.question_completion_percentage === 100) {
        colour = 'accent';
      } else if (this.question_completion_percentage >= 50) {
        colour = 'orange darken-2';
      }
      return colour;
    },
    ownerName() {
      return `${this.customer.owner.name.first} ${this.customer.owner.name.last}`;
    }
  },
  methods: {
    ...mapActions(['updateCustomer']),
    changeOwner(ownerId) {
      this.updateCustomer({
        id: this.customer.id,
        updates: {
          owner_id: ownerId
        }
      });
    },
    switchFlag: function(flag) {
      this.updateCustomer({
        id: this.customer.id,
        updates: {
          [flag]: !this.customer[flag]
        }
      });
    },
    toggleNewsletter() {
      this.updateCustomer({
        id: this.customer.id,
        updates: {
          ['newsletter_signup']: !this.customer.users[0].newsletter_signup
        }
      });
    }
  }
};
</script>
